import { render, staticRenderFns } from "./QueueActivity.vue?vue&type=template&id=a1a623ce&scoped=true"
import script from "./QueueActivity.vue?vue&type=script&lang=js"
export * from "./QueueActivity.vue?vue&type=script&lang=js"
import style0 from "./QueueActivity.vue?vue&type=style&index=0&id=a1a623ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a623ce",
  null
  
)

export default component.exports